import './vendor';
import "./wf_functions";
import "./common";
// require("./gallery"); не существует
import "./nav-main";
// require("./nav-mobile"); не существует
import "./nav-footer";
import "./comments";
import "./detail";
import "./bonuses";
import "./calculator";
import "./new-index";
import "./roasters-map";
import "./form-job";
import "./sidebar-sticky";
import "./search-lot-form";
import "./form-course-booking";
import "./detail-page";
import "./page-404";
import "./support-form";
import "./edu-forms";
import "./promo-slider";
import './personal/personal_app';
document.addEventListener('DOMContentLoaded', function () {
	refreshFsLightbox();
})
